import { Route, Switch } from "react-router-dom";

import Authenticate from "./Authenticate";
import RedirectToSso from "../RedirectToSso";

export default function AuthProvider({
}: React.PropsWithChildren<unknown>) {
  return (
    <Switch>
      <Route exact path="/redirect" component={Authenticate} />
      <Route component={RedirectToSso} />
    </Switch>
  );
}
